import React from 'react'
import styles from './extraActionsMenu.module.scss'
import { Text } from '@sendoutcards/quantum-design-ui'
import { MinimalCardPreviewFragment } from 'src/graphql/generated/graphql'
import Simple3DPreviewDialog from 'src/chrome/Simple3DPreviewDialog/Simple3DPreviewDialog'
import { useState } from 'src/hooks'

type ExtraActionsMenuProps = {
  card: MinimalCardPreviewFragment
  from: string
}

const ExtraActionsMenu: React.FC<ExtraActionsMenuProps> = props => {
  const { card, from } = props

  const [shouldShowMenu, setShouldShowMenu] = useState(false)
  const [shouldShowPreview, setShouldShowPreview] = useState(false)

  const onToggleMenu = () => {
    setShouldShowMenu(!shouldShowMenu)
  }

  const onClosePreview = () => {
    setShouldShowPreview(false)
  }

  const onShowPreview = () => {
    setShouldShowMenu(false)
    setShouldShowPreview(true)
  }

  return (
    <>
      <div className={styles.aditionalActions} onClick={onToggleMenu}>
        <div />
        <div />
        <div />
        <div
          className={`${styles.aditionalActionsMenu} ${shouldShowMenu ? styles.showMenu : ''}`}
        >
          <div onClick={onShowPreview}>
            <Text type="body" content="View Card" />
          </div>
        </div>
      </div>
      {shouldShowPreview && (
        <Simple3DPreviewDialog
          card={card}
          onClose={onClosePreview}
          title={`Card from: ${from}`}
        />
      )}
    </>
  )
}

export default ExtraActionsMenu
